// extracted by mini-css-extract-plugin
module.exports = {"container":"results_container__j48hs","spinner":"results_spinner__ISJ2b"};